import { defineComponent as S, openBlock as p, createElementBlock as y, normalizeClass as J, normalizeStyle as G, toDisplayString as $, ref as E, watch as f, onMounted as K, onUnmounted as Q, createElementVNode as M, renderSlot as j, useSlots as Y, computed as Z, unref as z, createBlock as I, withCtx as ee, Fragment as ie, createTextVNode as te, createCommentVNode as ne } from "vue";
const le = ["innerHTML"], se = {
  key: 1,
  class: "vue-ellipsis-native-text"
}, oe = /* @__PURE__ */ S({
  __name: "NativeEllipsis",
  props: {
    text: {
      type: String
    },
    visibleLine: {
      type: Number
    },
    ellipsis: {
      type: Boolean
    },
    useInnerHtml: {
      type: Boolean
    }
  },
  setup(i) {
    const e = i;
    return (t, l) => (p(), y("div", {
      class: J(["vue-ellipsis-native", { ellipsis: e.ellipsis }]),
      style: G({ webkitLineClamp: e.visibleLine })
    }, [
      e.useInnerHtml ? (p(), y("span", {
        key: 0,
        innerHTML: e.text,
        class: "vue-ellipsis-native-html"
      }, null, 8, le)) : (p(), y("span", se, $(e.text), 1))
    ], 6));
  }
});
const re = (i, e) => {
  const t = i.__vccOpts || i;
  for (const [l, r] of e)
    t[l] = r;
  return t;
}, ue = /* @__PURE__ */ re(oe, [["__scopeId", "data-v-e586cf55"]]);
function ce(i) {
  return i instanceof RegExp;
}
function O(i) {
  return typeof i == "string";
}
const _ = typeof window < "u" && typeof document < "u", ae = _ && typeof document.body.style.webkitLineClamp < "u", F = _ && typeof ResizeObserver < "u";
function T(i, e) {
  return window.getComputedStyle || (window.getComputedStyle = function(t) {
    return this.getPropertyValue = function(l) {
      const r = /(-([a-z]){1})/g;
      return l === "float" && (l = "styleFloat"), r.test(l) && (l = l.replace(r, function() {
        return arguments[2].toUpperCase();
      })), t.currentStyle && t.currentStyle[l] ? t.currentStyle[l] : null;
    }, this;
  }), window.getComputedStyle(i, null).getPropertyValue(e);
}
function de(i) {
  const e = T(i, "line-height");
  if (e === "normal") {
    const t = document.createElement("span");
    t.style.width = "300px", t.style.position = "absolute", t.style.visibility = "hidden", t.innerText = "ruofee", i.appendChild(t);
    const l = t.clientHeight;
    return i.removeChild(t), l * 1.1;
  }
  return parseFloat(e);
}
function fe(i) {
  const e = T(i, "word-break"), t = T(i, "overflow-wrap");
  if (e !== "word-break" && e !== "break-all" && t !== "break-word") {
    const l = i.style.wordBreak;
    return i.style.wordBreak = "break-word", l;
  }
}
function V(i, e) {
  i.style.wordBreak = e;
}
function pe(i, e) {
  return Math.floor((i + e) / 2);
}
function D(i, e, t, l) {
  for (; i < e; ) {
    const r = pe(i, e);
    if (l(i, e, r))
      break;
    t(i, e, r) ? e = r : i = r;
  }
}
function he(i) {
  const e = document.createElement("span");
  return e.className = "vue-ellipsis-js-content-text", e.textContent = i, e;
}
function P(i) {
  var e;
  !_ || (i.nodeType === Node.TEXT_NODE ? i.textContent && ((e = i.parentNode) == null || e.replaceChild(he(i.textContent), i)) : i.childNodes.forEach((t) => {
    P(t);
  }));
}
function b(i) {
  return i.clientHeight;
}
function q() {
  return [];
}
const ve = /* @__PURE__ */ S({
  __name: "JsEllipsis",
  props: {
    text: {
      type: String,
      required: !0
    },
    visibleLine: {
      type: Number,
      default: 1
    },
    visibleHeight: {
      type: Number
    },
    maxLine: {
      type: Number
    },
    maxHeight: {
      type: Number
    },
    ellipsis: {
      type: Boolean
    },
    endExcludes: {
      type: Array,
      default: q
    },
    useInnerHtml: {
      type: Boolean
    },
    reflowOnResize: {
      type: Boolean
    },
    onReflow: {
      type: Function
    },
    onEllipsisClick: {
      type: Function
    }
  },
  setup(i) {
    const e = i, t = E(), l = E(), r = E(), w = E(), H = E();
    f(() => e.text, c), f(() => e.ellipsis, c), f(() => e.useInnerHtml, c), f(() => e.maxLine, c), f(() => e.visibleLine, c), f(() => e.maxHeight, c), f(() => e.visibleHeight, c), f(() => e.endExcludes, c);
    function L(n, s) {
      var u;
      (u = e == null ? void 0 : e.onReflow) == null || u.call(e, n, s);
    }
    function A() {
      var n;
      (n = e == null ? void 0 : e.onEllipsisClick) == null || n.call(e);
    }
    function c() {
      if (!t.value || !l.value || !r.value || w.value || (r.value.style.display = "none", e.useInnerHtml ? l.value.innerHTML = e.text : l.value.innerText = e.text, !e.ellipsis))
        return;
      const n = de(t.value), s = fe(l.value), u = typeof e.visibleHeight > "u" ? n * e.visibleLine : e.visibleHeight, a = typeof e.maxHeight > "u" ? typeof e.maxLine > "u" ? u : n * e.maxLine : e.maxHeight;
      if (b(t.value) <= Math.max(a, u)) {
        L(!1, e.text), O(s) && V(l.value, s);
        return;
      }
      w.value = !0, r.value.style.display = "inline", e.useInnerHtml ? (P(l.value), k(t.value, l.value, u)) : B(t.value, l.value, u), O(s) && V(l.value, s), w.value = !1;
    }
    function B(n, s, u) {
      const a = s.textContent || "";
      let o = "";
      D(
        0,
        a.length,
        (d, h, v) => {
          const N = a.slice(d, v);
          s.innerText = o + N;
          const m = b(n) > u;
          return m || (o += N), m;
        },
        (d, h, v) => d === v
      ), o = X(o), s.innerText = o, L(!0, o);
    }
    function k(n, s, u) {
      const a = s.childNodes;
      if (a.length === 1) {
        const o = a[0];
        if (o.nodeType === Node.TEXT_NODE)
          B(n, s, u);
        else {
          const d = o.innerHTML;
          if (o.innerHTML = "", b(n) > u) {
            s.removeChild(o), L(!0, s.innerHTML);
            return;
          }
          o.innerHTML = d, k(n, o, u);
        }
      } else {
        const o = [].slice.call(a), d = [];
        let h = 0;
        D(
          0,
          o.length,
          (v, N, g) => {
            s.innerHTML = "";
            const m = o.slice(v, g);
            d.forEach((x) => {
              s.appendChild(x);
            }), m.forEach((x) => {
              s.appendChild(x);
            });
            const C = b(n) > u;
            return C || m.forEach((x) => {
              d.push(x);
            }), C;
          },
          (v, N, g) => {
            if (v === g) {
              const R = b(n) > u;
              return h = g, R || s.appendChild(o[h]), !0;
            }
            return !1;
          }
        ), s.childNodes[h] && k(n, s.childNodes[h], u);
      }
    }
    function U(n) {
      for (const s of e.endExcludes)
        if (ce(s)) {
          if (s.test(n))
            return !0;
        } else if (s === n)
          return !0;
      return !1;
    }
    function X(n) {
      for (; !!n.length && U(n[n.length - 1]); )
        n = n.slice(0, -1);
      return n;
    }
    return K(() => {
      c(), t.value && e.reflowOnResize && (F ? (H.value = new ResizeObserver(c), H.value.observe(t.value)) : window.addEventListener("resize", c));
    }), Q(() => {
      var n, s;
      F && H.value ? (s = (n = H.value) == null ? void 0 : n.disconnect) == null || s.call(n) : window.removeEventListener("resize", c);
    }), (n, s) => (p(), y("div", {
      ref_key: "aref",
      ref: t,
      class: "vue-ellipsis-js"
    }, [
      M("span", {
        ref_key: "textRef",
        ref: l,
        class: "vue-ellipsis-js-content"
      }, null, 512),
      M("span", {
        ref_key: "ellipsisRef",
        ref: r,
        class: "vue-ellipsis-js-ellipsis",
        onClick: A
      }, [
        j(n.$slots, "ellipsisNode")
      ], 512)
    ], 512));
  }
}), W = "...", me = { class: "vue-ellipsis" }, ye = /* @__PURE__ */ S({
  __name: "index",
  props: {
    text: {
      type: String,
      required: !0
    },
    visibleLine: {
      type: Number,
      default: 1
    },
    visibleHeight: {
      type: Number
    },
    maxLine: {
      type: Number
    },
    maxHeight: {
      type: Number
    },
    ellipsis: {
      type: Boolean,
      default: !0
    },
    ellipsisNode: {
      type: String,
      default: W
    },
    endExcludes: {
      type: Array,
      default: q
    },
    useInnerHtml: {
      type: Boolean,
      default: !1
    },
    reflowOnResize: {
      type: Boolean,
      default: !1
    },
    onReflow: {
      type: Function
    },
    onEllipsisClick: {
      type: Function
    }
  },
  setup(i) {
    const e = i, t = Y(), l = Z(() => ae && (typeof e.maxLine > "u" || e.maxLine === e.visibleLine) && e.endExcludes.length === 0 && e.ellipsisNode === W && typeof t.ellipsisNode > "u" && typeof e.maxHeight > "u" && typeof e.visibleHeight > "u" && typeof e.onReflow > "u" && typeof e.onEllipsisClick > "u");
    return (r, w) => (p(), y("div", me, [
      z(l) ? (p(), I(ue, {
        key: 0,
        text: e.text,
        "visible-line": e.visibleLine,
        ellipsis: e.ellipsis,
        "use-inner-html": e.useInnerHtml
      }, null, 8, ["text", "visible-line", "ellipsis", "use-inner-html"])) : (p(), I(ve, {
        key: 1,
        text: i.text,
        "use-inner-html": i.useInnerHtml,
        "visible-line": i.visibleLine,
        "visible-height": i.visibleHeight,
        "max-line": i.maxLine,
        "max-height": i.maxHeight,
        ellipsis: i.ellipsis,
        "end-excludes": i.endExcludes,
        "reflow-on-resize": i.reflowOnResize,
        "on-reflow": i.onReflow,
        "on-ellipsis-click": i.onEllipsisClick
      }, {
        ellipsisNode: ee(() => [
          z(t).ellipsisNode ? ne("", !0) : (p(), y(ie, { key: 0 }, [
            te($(i.ellipsisNode), 1)
          ], 64)),
          j(r.$slots, "ellipsisNode")
        ]),
        _: 3
      }, 8, ["text", "use-inner-html", "visible-line", "visible-height", "max-line", "max-height", "ellipsis", "end-excludes", "reflow-on-resize", "on-reflow", "on-ellipsis-click"]))
    ]));
  }
}), xe = {
  install: (i) => {
    i.component("VueEllipsis3", ye);
  }
};
export {
  ye as VueEllipsis3,
  xe as default
};
(function() {try {var elementStyle = document.createElement('style');elementStyle.innerText = ".vue-ellipsis-native.ellipsis[data-v-e586cf55]{display:-webkit-box;overflow:hidden;text-overflow:ellipsis;word-break:break-word;-webkit-box-orient:vertical}\n";document.head.appendChild(elementStyle);} catch(error) {console.error(error, 'unable to concat style inside the bundled file')}})()